import { useMemo } from "react";
import { Badge } from "@mantine/core";
import type { AggregateState } from "../../services/reportDeliveryRecall.service";

interface ReportDeliveryStateBadgeProps {
  state: AggregateState;
  onClick?: () => void;
  actionLabel?: string;
}

const LABELS: Record<AggregateState, string> = {
  none: "Not queued",
  queued: "Queued",
  recalled: "Report recalled",
  partial_recall: "Partial recall",
  sending: "Sending",
  delivered: "Report delivered",
  failed: "Failed",
  cancelled: "Cancelled",
  mixed: "Mixed delivery",
  incomplete: "Delivery incomplete",
};

const COLORS: Record<AggregateState, string> = {
  none: "gray",
  queued: "blue",
  recalled: "orange",
  partial_recall: "red",
  sending: "yellow",
  delivered: "green",
  failed: "red",
  cancelled: "gray",
  mixed: "orange",
  incomplete: "orange",
};

export function ReportDeliveryStateBadge({
  state,
  onClick,
  actionLabel,
}: ReportDeliveryStateBadgeProps) {
  const label = useMemo(() => LABELS[state], [state]);
  const color = useMemo(() => COLORS[state], [state]);

  return (
    <Badge
      color={color}
      variant="light"
      component={onClick ? "button" : "span"}
      onClick={onClick}
      aria-label={
        onClick ? actionLabel ?? `View ${label} delivery details` : undefined
      }
      style={
        onClick
          ? { cursor: "pointer", minHeight: 44, paddingInline: 12 }
          : undefined
      }
    >
      {label}
    </Badge>
  );
}
